import React from "react";
import { Box, Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import ordersStyles from "../../Pages/Orders/Orders.styles";
import { selectOrderById } from "../../redux/state/orders/orders.selectors";
import { deleteOrderThunk, extendOrderThunk } from "../../redux/state/orders/orders.fetch";
import Notiflix from 'notiflix';
import { useNavigate } from "react-router-dom";

function OrderActions({ theme }) {
  const dispatch = useDispatch();
  const order = useSelector(selectOrderById);
  const navigate = useNavigate();  

  const handleExtendOrder = () => {
    if (order?._id) {
      dispatch(extendOrderThunk(order._id))
        .unwrap() 
        .then((result) => {
          if (result?.success) {
            
            Notiflix.Notify.success(`Заявка продлена до ${new Date(result.expiresAt).toLocaleString()}`);
          }
        })
        .catch((error) => {
          Notiflix.Notify.failure(error?.error || "Сейчас продлить нельзя, попробуйте позже");
        });
    }
  };

  const handleDeleteOrder = () => {
    if (order?._id) {
      dispatch(deleteOrderThunk(order._id))
        .unwrap()
        .then(() => {
          Notiflix.Notify.success("Заявка отменена");
          navigate("/");  
        })
        .catch((error) => {
          Notiflix.Notify.failure(error?.error || "Не удалось отменить заявку");
        });
    }
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2,  }}>
      <Button
        variant="contained"
        color="primary"
        sx={ordersStyles(theme).button}
        onClick={handleExtendOrder}
      >
        ПРОДЛИТЬ
      </Button>
      <Button
        variant="contained"
        color="error"
        sx={ordersStyles(theme).buttonCancel}
        onClick={handleDeleteOrder}
      >
        ОТМЕНИТЬ 
      </Button>
    </Box>
  );
}

export default OrderActions;
